import { FlatList, Text, TouchableOpacity, View } from "react-native";
import { THEME_COLORS } from "../../../../common/styles";
import {
  Checkbox,
  CustomButton,
  CustomSelect,
  ImageAlbum,
  ModalView,
  TableComponent,
  TabOne,
} from "../../../../common/component";
import { AssignWorkshopAndAdvisorMutation } from "../../container/AssignWorkshopAndAdvisor";
import { GetWorkshopListData } from "../../container/GetWorkshopList";
import React, { useState } from "react";
import { GetAdvisorForWorkshopData } from "../../container/GetAdvisorForWorkshop";
import { MarkAssignMentMutation } from "../../container/MarkAssignmentMutation";
import { ReassignWorkshopAndAdvisorMutation } from "../../container/ReassignWorkshopAndAdvisor";
import { GetJobCardJobRowData } from "../../container/GetJobCardJobRowData";
import { RootContext } from "../../../../App";
import { FONT_FAMILY, images } from "../../../../common/themes";
import MaterialCheckbox from "@mui/material/Checkbox";
import { ImageAlbumButton } from "../../../../common/component/BeforeAfterImages";
import { TooltipV3 } from "../../../../common/component";

interface IAssignJobListViewProps {
  jobList: any;
}

const AssignJobListView = (props: IAssignJobListViewProps) => {
  const [selectedJobRowIds, setSelectedJobRowIds] = useState({});
  const selectJobRowId = (jobRowId) => {
    setSelectedJobRowIds((prevState) => {
      if (isJobRowIdSelected(jobRowId, prevState)) return prevState;
      const newState = Object.assign({}, prevState);
      newState[jobRowId] = true;
      return newState;
    });
  };
  const deselectJobRowId = (jobRowId) => {
    setSelectedJobRowIds((prevState) => {
      if (!isJobRowIdSelected(jobRowId, prevState)) return prevState;
      const newState = Object.assign({}, prevState);
      delete newState[jobRowId];
      return newState;
    });
  };
  const isJobRowIdSelected = (jobRowId, selectedJobRowIds) => {
    return selectedJobRowIds.hasOwnProperty(jobRowId);
  };
  const clearSelectedJobRowIds = () => {
    setSelectedJobRowIds({});
  };
  const [assignWorkshop, setAssignWorkshop] = useState(null);
  const [selectedCgt, setSelectedCgt] = useState(null);
  const [reassignJobCardId, setReassignJobCardId] = useState(null);
  const { jobList } = props;
  const jobListId = jobList.id;
  const { setValue } = React.useContext(RootContext);
  const { jobRows, isAssignmentDone } = jobList;
  const row = [
    { label: "Car Part", type: "carPart", style: { flex: 12 } },
    { label: "Issues", type: "map", style: { flex: 10 } },
    { label: "Fixes", type: "map", style: { flex: 10 } },
    { label: "Total Estd. Cost", type: "totalCost", style: { flex: 10 } },
    { label: "Workshop", type: "workshop", style: { flex: 10 } },
    { label: "CGT", type: "cgt", style: { flex: 10 } },
    { label: "Status", type: "status", style: { flex: 10 } },
  ];
  if (!isAssignmentDone) row.unshift({ label: "Action", type: "action", style: { flex: 4 } });
  const mappedData = jobRows.map((jobRow) => {
    const carPartName = jobRow.carPart.name;
    const images = jobRow.inspectionMedia?.map((item) => ({ url: item[0], mediaType: item[1] })) || [];
    const { subJobRow, workshopJobrows } = jobRow;
    const amount = [jobRow.amount, jobRow.estimatePartCost, jobRow.estimateLabourCost];
    const issues = subJobRow.map((subJobRow) => `${subJobRow?.issue?.name}`);
    const fixes = subJobRow.map((subJobRow) => `${subJobRow.fixes.map((fix) => fix.name).join(", ")}`);
    let dataRow = JSON.parse(JSON.stringify(row));
    dataRow[0]["value"] = { carPartName, images };
    dataRow[1]["value"] = issues;
    dataRow[2]["value"] = fixes;
    dataRow[3]["value"] = amount;
    dataRow[4]["value"] = workshopJobrows;
    dataRow[5]["value"] = workshopJobrows;
    dataRow[6]["value"] = workshopJobrows;

    if (!isAssignmentDone) {
      dataRow[0]["value"] = {
        isAssignable: jobRow.isAssignableToWorkshop,
        isSelected: isJobRowIdSelected(jobRow.id, selectedJobRowIds),
        jobRowId: jobRow.id,
      };
      dataRow[1]["value"] = { carPartName, images };
      dataRow[2]["value"] = issues;
      dataRow[3]["value"] = fixes;
      dataRow[4]["value"] = amount;
      dataRow[5]["value"] = workshopJobrows;
      dataRow[6]["value"] = workshopJobrows;
      dataRow[7]["value"] = workshopJobrows;
    }
    dataRow[0]["id"] = jobRow.id;
    return dataRow;
  });

  const renderColumn = (obj) => {
    const style = obj.style;
    if (obj.type === "text")
      return (
        <Text style={[obj.style, { fontFamily: FONT_FAMILY.two, fontSize: 15, flexWrap: "wrap", letterSpacing: 0.1 }]}>
          {obj.value}
        </Text>
      );
    else if (obj.type === "carPart")
      return (
        <View style={[style, { alignItems: "flex-start" }]}>
          <Text
            style={[
              { flexWrap: "wrap", fontFamily: FONT_FAMILY.two, fontSize: 15, letterSpacing: 0.1, marginBottom: 8 },
            ]}
          >
            {obj.value.carPartName}
          </Text>
          <ImageAlbumButton images={obj.value.images} />
        </View>
      );
    if (obj.type === "map")
      return (
        <View style={[style, { alignItems: "flex-start" }]}>
          {obj.value.map((item) => (
            <Text style={{ fontFamily: FONT_FAMILY.two, fontSize: 15, letterSpacing: 0.1 }}>{item}</Text>
          ))}
        </View>
      );
    if (obj.type === "totalCost")
      return (
        <View style={[style, { alignItems: "flex-start" }]}>
          <Text style={{ fontFamily: FONT_FAMILY.three, fontSize: 14, letterSpacing: 0.1 }}>
            Total Cost {obj.value[0]}
          </Text>
          <Text style={{ fontFamily: FONT_FAMILY.two, fontSize: 15, letterSpacing: 0.1 }}>
            Part Cost {obj.value[1]}
          </Text>
          <Text style={{ fontFamily: FONT_FAMILY.two, fontSize: 15, letterSpacing: 0.1 }}>
            Labour Cost {obj.value[2]}
          </Text>
        </View>
      );
    if (obj.type === "workshop")
      return obj.value.map((wjrm) => (
        <TooltipV3 title={wjrm?.workshop?.displayName}>
          <Text
            style={{
              fontSize: 15,
              fontFamily: FONT_FAMILY.two,
              letterSpacing: 0.1,
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
              wordBreak: "break-word",
            }}
          >
            {wjrm?.workshop?.displayName ?? "-"}
          </Text>
        </TooltipV3>
      ));
    if (obj.type === "cgt")
      return obj.value.map((wjrm) => (
        <Text style={{ fontSize: 15, fontFamily: FONT_FAMILY.two, letterSpacing: 0.1 }}>
          {wjrm?.user?.fullName ?? "-"}
        </Text>
      ));
    if (obj.type === "status")
      return obj.value.map((wjrm) => {
        let status = !!wjrm.status ? wjrm.status.label : "";
        let color = !!wjrm.status ? wjrm.status.color : THEME_COLORS.black2;
        let comment = !!wjrm.status ? wjrm.status.textStyle : "";
        let otherComment = "";

        return (
          <View>
            <Text style={{ fontSize: 15, color: color, flex: 1, fontFamily: FONT_FAMILY.three }}>{status}</Text>
            <Text style={{ fontSize: 15, fontFamily: FONT_FAMILY.two, flex: 1 }}>
              {!!comment ? comment.replace("_", " ").toLowerCase() : ""}
              {!!otherComment ? `- ${otherComment}` : null}
            </Text>
          </View>
        );
      });
    if (obj.type === "action" && obj.label === "Action") {
      const { isAssignable, isSelected, jobRowId } = obj.value;
      const isCheckboxDisabled = !isAssignable;
      return (
        <MaterialCheckbox
          checked={isSelected}
          disabled={isCheckboxDisabled}
          onChange={() => {
            if (isSelected) deselectJobRowId(jobRowId);
            else {
              selectJobRowId(jobRowId);
            }
          }}
          style={{
            alignSelf: "flex-start",
            transform: "scale(0.8)",
            padding: 0,
          }}
        />
      );
    }
  };

  const isAnyJobRowSelected = Object.keys(selectedJobRowIds).length > 0;
  return (
    <>
      <TableComponent
        headerColumns={row}
        rowData={mappedData}
        renderColumn={renderColumn}
        selectedRowsStyle={{ backgroundColor: "#FFF0F0" }}
        selectedRowsId={Object.keys(selectedJobRowIds)}
      />
      {!!reassignJobCardId ? (
        <GetJobCardJobRowData jobCardId={reassignJobCardId}>
          {(jobCard) => {
            const advisorNames = "A: " + jobCard.metaData.advisors.map((adv) => adv.name).join(", ");
            return (
              <ModalView
                show={!!reassignJobCardId}
                size={"small"}
                onClose={() => {
                  setReassignJobCardId(null);
                }}
                headerContent={
                  <TabOne
                    topText={"Workshop"}
                    bottomText={`${jobCard.workshop.displayName || "N/A"}`}
                    bottomSecondText={`${advisorNames}`}
                    isSelected={true}
                    onPress={() => {}}
                  />
                }
              >
                <FlatList
                  data={jobCard.jobRows}
                  style={{ marginLeft: 5 }}
                  renderItem={({ item, index }) => {
                    const issues = item.jobRow.subJobRow.map(
                      (subJobRow) => `${subJobRow.issue.name}: ${subJobRow.fixes.map((fix) => fix.name).join(", ")}`
                    );
                    return (
                      <View style={{ flexDirection: "row", marginVertical: 10 }}>
                        <View style={{ flex: 3 }}>
                          <Text>
                            {index + 1}. {item.jobRow.carPart.name}
                          </Text>
                        </View>
                        <View style={{ flex: 5 }}>
                          {issues.map((issue) => {
                            return <Text>{issue}</Text>;
                          })}
                        </View>
                      </View>
                    );
                  }}
                  keyExtractor={(item, index) => `${item.id}_${index}`}
                />
                <ReassignWorkshopAndAdvisorMutation>
                  {({ reassignWorkshopAndAdvisorMutation }) => (
                    <View style={{ flexDirection: "row", justifyContent: "flex-end", paddingRight: 10 }}>
                      <GetWorkshopListData isJobRowAssignable={true}>
                        {(workshopList) => (
                          <CustomSelect
                            labelField={"displayName"}
                            valueField={"id"}
                            options={workshopList}
                            values={!!assignWorkshop ? [assignWorkshop] : []}
                            onChange={(obj) => {
                              setAssignWorkshop(obj[0]);
                            }}
                            searchBy={"displayName"}
                            fieldName={"Workshop"}
                          />
                        )}
                      </GetWorkshopListData>
                      <View style={{ width: 30 }}></View>
                      <GetAdvisorForWorkshopData workshopIds={!!assignWorkshop ? [assignWorkshop.id] : []}>
                        {(advisorList) => (
                          <CustomSelect
                            labelField={"fullName"}
                            valueField={"id"}
                            options={advisorList}
                            values={[]}
                            onChange={(obj) => {
                              const userId = obj[0].id;
                              if (!confirm("Are you sure ?")) return null;
                              reassignWorkshopAndAdvisorMutation({
                                variables: {
                                  jobCardId: reassignJobCardId,
                                  advisorUserId: userId,
                                  workshopId: assignWorkshop.id,
                                },
                              })
                                .then((data) => {
                                  alert("success");
                                  setReassignJobCardId(null);
                                })
                                .catch((e) => {
                                  alert(e.message);
                                });
                            }}
                            searchBy={"fullName"}
                            fieldName={"Advisor"}
                          />
                        )}
                      </GetAdvisorForWorkshopData>
                    </View>
                  )}
                </ReassignWorkshopAndAdvisorMutation>
              </ModalView>
            );
          }}
        </GetJobCardJobRowData>
      ) : null}
      {isAnyJobRowSelected || !isAssignmentDone ? (
        <View
          style={{
            flexDirection: "row",
            height: 50,
            marginTop: 20,
            zIndex: 10,
            justifyContent: "space-between",
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
            {isAnyJobRowSelected ? (
              <>
                <GetWorkshopListData isJobRowAssignable={true}>
                  {(workshopList) => (
                    <CustomSelect
                      style={{
                        backgroundColor: "rgb(245,245,245)",
                        borderWidth: 1,
                        borderColor: "rgb(240,240,240)",
                        borderRadius: 5,
                        minWidth: 180,
                        boxShadow: "none",
                        height: 40,
                        paddingHorizontal: 10,
                        marginVertical: 0,
                      }}
                      placeholderTxtStyle={{ fontFamily: FONT_FAMILY.three, fontSize: 14 }}
                      labelField={"displayName"}
                      valueField={"id"}
                      options={workshopList}
                      values={!!assignWorkshop ? [assignWorkshop] : []}
                      onChange={(obj) => {
                        setAssignWorkshop(obj[0]);
                        setSelectedCgt(null);
                      }}
                      searchBy={"displayName"}
                      fieldName={"Workshop"}
                    />
                  )}
                </GetWorkshopListData>
                <View style={{ width: 30 }}></View>
                <GetAdvisorForWorkshopData workshopIds={!!assignWorkshop ? [assignWorkshop.id] : []}>
                  {(advisorList) => (
                    <CustomSelect
                      style={{
                        backgroundColor: "rgb(245,245,245)",
                        borderWidth: 1,
                        borderColor: "rgb(240,240,240)",
                        borderRadius: 5,
                        minWidth: 180,
                        boxShadow: "none",
                        height: 40,
                        paddingHorizontal: 10,
                        marginVertical: 0,
                      }}
                      placeholderTxtStyle={{ fontFamily: FONT_FAMILY.three, fontSize: 14 }}
                      labelField={"fullName"}
                      valueField={"id"}
                      options={advisorList}
                      values={!!selectedCgt ? [selectedCgt] : []}
                      onChange={(obj) => {
                        setSelectedCgt(obj[0]);
                      }}
                      searchBy={"fullName"}
                      fieldName={"Advisor"}
                    />
                  )}
                </GetAdvisorForWorkshopData>
              </>
            ) : null}
          </View>
          <View>
            {isAnyJobRowSelected ? (
              <AssignWorkshopAndAdvisorMutation>
                {({ assignWorkshopAndAdvisorMutation }) => (
                  <CustomButton
                    textStyle={{ fontFamily: FONT_FAMILY.three, fontSize: 16 }}
                    text={"Assign Workshop"}
                    style={{ height: 40, marginHorizontal: 0, marginVertical: 0, borderRadius: 6, width: 175 }}
                    onPress={() => {
                      const jobRowIds = Object.keys(selectedJobRowIds);
                      if (!assignWorkshop) return alert("Please Select Workshop first");
                      if (!selectedCgt) return alert("Please Select CGT first");
                      if (!confirm("Are you sure ?")) return null;
                      assignWorkshopAndAdvisorMutation({
                        variables: {
                          data: {
                            jobRowIds,
                            jobListId,
                            workshopId: assignWorkshop.id,
                            userId: selectedCgt.id,
                          },
                        },
                      })
                        .then((data) => {
                          alert("success");
                          clearSelectedJobRowIds();
                        })
                        .catch((e) => {
                          alert(e.message);
                        });
                    }}
                  />
                )}
              </AssignWorkshopAndAdvisorMutation>
            ) : (
              <MarkAssignMentMutation>
                {({ markAssignmentMutation }) => (
                  <CustomButton
                    text={"Complete Assignment"}
                    textStyle={{ fontFamily: FONT_FAMILY.three, fontSize: 16 }}
                    style={{ height: 40, marginHorizontal: 0, marginVertical: 0, borderRadius: 6, width: 175 }}
                    onPress={() => {
                      if (!confirm("Are you sure you want to complete assignment?")) return null;
                      markAssignmentMutation({
                        variables: {
                          jobListId: jobListId,
                        },
                      })
                        .then((data) => {
                          alert("success");
                          if (setValue) setValue({ shouldRefetchInventory: true });
                        })
                        .catch((e) => {
                          alert(e.message);
                        });
                    }}
                  />
                )}
              </MarkAssignMentMutation>
            )}
          </View>
        </View>
      ) : null}
    </>
  );
};

export default AssignJobListView;
